export const environment = {
  production: false,
  // Chat corporativo (Zulip). Se abre en pestaña nueva: el servidor bloquea iframes.
  urlChat: 'https://chats.smartglobalsales.com/',
  name: 'dev',
  tipificacionesMetricasEnabled: true,
  firebase: {
    config: {
      apiKey: 'AIzaSyCXlycEKPSxliqwfgHzUBYHQWMdTIWHdTM',
      authDomain: 'dotval-app.firebaseapp.com',
      projectId: 'dotval-app',
      storageBucket: 'dotval-app.appspot.com',
      messagingSenderId: '1036953496333',
      appId: '1:1036953496333:web:9de32d5210bb89dc80de44',
      measurementId: 'G-Z3BPHDP2NK',
    },
  },
  // Para desarrollo local
  //url: 'http://localhost:9099/',
  //urlSms: 'http://localhost:9040',

  // Para producción (comentado)
  urlVentas: 'https://apisozarusac.com/ventasBackup/api/',
  // Endpoint de metricas de bases (mismo backend de Ventas de Lima).
  urlVentasMetricas: 'https://apisozarusac.com/ventasBackup/api/',
  url: 'https://apisozarusac.com/BackendJavaMidas/',
  // Hub Vodafone (agente oficina hace poll aquí)
  urlAsistencias: 'https://apisozarusac.com/v2/',
  // Solo pruebas con agente en la MISMA PC:
  // urlVodafone: 'http://127.0.0.1:8001/',
  apiUrl: 'https://apisozarusac.com/Coaching/api/',
  urlSms: 'https://apisozarusac.com/BackendArchivos',
  // Microservicio integrador (botón «Estados RetailX», igual que en el CRM mass34).
  urlIntegrador: 'https://ivr.mass34.com/integrador/',
  // Token interno del integrador (cabecera X-Integrador-Token).
  integradorToken: '672cd92fe6a235101a4f5fe823c080047a760278dadbf300ccbcab494d84f441',

  // OpenAI API para mejorar mensajes SMS
  openaiApiKey:
    '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',
  openaiProjectId: 'proj_QacCygZXBlfqc0yVu8txwa2X',
  // Configuración de mapas
  maps: {
    // 1 = Leaflet (Nominatim/Catastro), 0 = Mapbox
    mapaTipificacionLeaflet: 0,
    mapaTipificacionMapbox: 1, // Activar Mapbox por defecto
    // Token de Mapbox (reemplazar con token real)
    mapboxToken:
      'pk.eyJ1Ijoic21vb3RoMjQ0NCIsImEiOiJjbWFyNWM3MW4wMXh0MnRxOGNqNmRxNjN2In0.iZrZvfUCqEWMo-SOzmHTxg',
  },
};
